import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import Method from "./pages/Method";
import Science from "./pages/Science";
import About from "./pages/About";
import Articles from "./pages/Articles";
import Article from "./pages/Article";
import Pricing from "./pages/Pricing";
import { Privacy, Terms, Cookies } from "./pages/Legal";
import NotFound from "./pages/NotFound";
import Newsletter from "./pages/Newsletter";

export const APP_URL = "https://app.px7.training";

export default function App() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/method" element={<Method />} />
          <Route path="/science" element={<Science />} />
          <Route path="/about" element={<About />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<Article />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
